import { setContext, close } from '@sentry/nuxt'

export default defineNuxtPlugin(nuxtApp => {
  const authStore = useAuthStore()
  const wishlistStore = useWishlistStore()
  const cartStore = useCartStore()
  const userStore = useUserStore()

  watch(() => userStore.id, () => setContext('Guts User', { id: userStore.id, uniqueId: userStore.uniqueId }), { immediate: true })
  watch(() => wishlistStore.wishlistId, () => setContext('Wishlist', { id: wishlistStore.wishlistId }), { immediate: true })
  watch(() => cartStore.cartId, () => setContext('Cart', { id: cartStore.cartId }), { immediate: true })
  watch(() => authStore.loggedIn, () => setContext('Auth', { loggedIn: authStore.loggedIn }), { immediate: true })

  /**
   * When a chunk-error happens, nuxt force-reloads the whole page.
   * While this reload is happening, fetch-calls which are still active are aborted suddenly. This causes unwanted errors in Sentry.
   */
  nuxtApp.hook('app:chunkError', () => {
    close()
  })
})
